<!--
Modal

A simple modal component that can contain an other component
-->

<template>
	<FocusLock v-if="modalOpen" returnFocus="true">
		<div
			class="o-modal"
			v-bind:class="[{ 'o-modal--open': modalOpen }, modalClasses]"
		>
			<component
				:is="{ ...modalInner }"
				v-bind="modalProps"
				class="a-fade__content"
			></component>
			<button v-on:click="closeModal()" class="o-modal__close o-inline-icon">
				<span class="o-inline-icon__text">Close</span>
				<span class="o-inline-icon__icon icon i-close">
					<crossIcon />
				</span>
			</button>
		</div>
	</FocusLock>
</template>

<script>
	import crossIcon from '/web/static/images/svgs/icon-cross.svg?component';
	import FocusLock from 'vue-focus-lock';

	export default {
		name: "v-modal",
		components: {
			crossIcon,
			FocusLock
		},
		data() {
			return {
				page: null
			};
		},
		computed: {
			modalOpen() {
				// console.log("changed", this.$store.state.modalOpen);

				if(this.page) {
					if(this.$store.state.modalOpen) {
						this.page.style.overflow = "hidden";
					} else {
						this.page.style.removeProperty("overflow");
					}
				}

				return this.$store.state.modalOpen;
			},
			modalInner() {
				return this.$store.state.modalContent;
			},
			modalProps() {
				return this.$store.state.modalProps;
			},
			modalClasses() {
				return this.$store.state.modalClasses;
			},
		},
		mounted: function () {
			this.page = document.documentElement;

			document.addEventListener("keydown", (e) => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		methods: {
			closeModal() {
				if (this.modalOpen) {
					this.$store.commit("closeModal");

					if (document.getElementById(this.$store.state.modalTrigger) != null) {
						document.getElementById(this.$store.state.modalTrigger).focus();
						//clean up any hash
						window.history.replaceState(null, null, " ");
					}
				}
			},
		},
	};
</script>
